<template>
  <div>
    <v-btn color="primary" to="/banner" depressed text
      ><v-icon>mdi-arrow-left</v-icon> Kembali</v-btn
    >

    <div
      :style="
        $vuetify.breakpoint.xs
          ? 'width:100%;margin:0 auto'
          : 'width:85vw;margin:0 auto'
      "
    >
      <br />

      <center>
        <h2>{{ banners.nama }}</h2>
        <div
          v-viewer="{ movable: true }"
          style="height: 300px; max-height: 300px; overflow: hidden"
        >
          <img
            style="
              width: 100%;
              height: 100%;
              cursor: pointer;
              object-fit: contain;
            "
            class="ma-2"
            :src="
              $vuetify.breakpoint.xs
                ? $url_img + banners.foto
                : $url_img + banners.foto_web
            "
          />
        </div>
      </center>
      <br /><br /><br />
      <v-card
        style="border:1px solid #af0000"
        min-height="100px"
        color="#c90000"
      >
        <v-card
          min-height="100px"
          :class="$vuetify.breakpoint.xs ? 'mx-2' : 'mx-6'"
          style="margin-bottom:25px;margin-top:-45px;border:1px solid white"
        >
          <div
            :style="
              $vuetify.breakpoint.xs
                ? 'width:95%;margin:20px auto;border:1px solid white'
                : 'width:80%;margin:20px auto;border:1px solid white'
            "
          >
            <template v-if="deskripsi.length > 0">
              <div v-for="(item, index) in deskripsi" :key="index">
                <div v-if="item.includes('https://www.youtube.com')">
                  <center>
                    <youtube
                      :player-vars="{ autoplay: 2 }"
                      :player-width="$vuetify.breakpoint.xs ? '100%' : 500"
                      :player-height="$vuetify.breakpoint.xs ? 300 : 300"
                      :video-id="
                        item.replace('https://www.youtube.com/watch?v=', '')
                      "
                    />
                  </center>
                </div>
                <div v-if="listIdIklan.includes(item)">
                  <template v-for="(iklan, index) in listIklan">
                    <iklan-banner
                      v-if="iklan._source.id == item"
                      :key="index"
                      :item="item"
                      :iklan="iklan"
                    />
                  </template>
                </div>
                <div
                  class="py-2"
                  v-html="item"
                  v-if="
                    !listIdIklan.includes(item) &&
                      !item.includes('https://www.youtube.com')
                  "
                ></div>
              </div>
            </template>
          </div>
        </v-card>
      </v-card>
    </div>
    <br />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import Vue from 'vue';
Vue.use(VueViewer);
export default {
  name: 'preview',

  data: () => ({
    banners: [],
    listIdIklan: [],
    listIklan: [],
    listIdYt: [],
    deskripsi: [],
    descTemp: '',
    pos: 0,
    userToken: null
  }),
  components: {
    IklanBanner: () =>
      import(
        /* webpackChunkName: "iklan-banner" */ '@/components/IklanBanner.vue'
      )
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      utc: 'timezone/utc',
      timezone: 'timezone/region'
    })
  },
  methods: {
    async showBanners() {
      await this.$req
        .get(this.$root.$baseapi.master+'/master/v3/mst_banner_admin', {
          params: {
            id: this.$route.params.id
          },
          headers: { Authorization: 'Bearer ' + this.userToken }
        })
        .then(response => {
          let { data } = response.data;
          this.banners = data[0];
          this.olahText();
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async getIklan() {
      let params = new URLSearchParams();

      for (let i = 0; i < this.listIdIklan.length; i++) {
        params.append('id', this.listIdIklan[i]);
      }
      params.append('limit', 100);

      let request = {
        params: params
      };

      await this.$req
        .get(this.$root.$baseapi.search+'/search/v4/search', request)
        .then(response => {
          // let data = response.data
          // let { hits } = data.hits
          // this.iklanTerbaru.push(...hits)

          if (response.data.hits.hits != null) {
            this.listIklan = response.data.hits.hits;
          }

          console.log('res', this.listIklan);

          // this.iklanTerbaruTb = []
          // this.total = data.hits.total.value
          // this.lengthPage = Math.ceil(this.total / this.limit)
          // this.page++
          // console.log('tot', data.hits.total.value)
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    addString(str, index, stringToAdd) {
      this.banners.deskripsi =
        str.substring(0, index) +
        stringToAdd +
        str.substring(index, str.length);
    },
    olahText() {
      for (let i = 0; i < 20; i++) {
        if (this.banners.deskripsi.includes('<iklan>')) {
          this.pos = 0;
          this.pos = this.banners.deskripsi.search('<iklan>');
          this.addString(this.banners.deskripsi, this.pos, '<baris>');
          this.pos = 0;
          this.pos = this.banners.deskripsi.search('</iklan>');
          this.addString(this.banners.deskripsi, this.pos + 8, '<baris>');
          let yDesc = this.banners.deskripsi.replace('<iklan>', '<adaiklan>');
          this.banners.deskripsi = yDesc.replace('</iklan>', '</adaiklan>');
        }
        if (this.banners.deskripsi.includes('<youtube>')) {
          this.pos = 0;
          this.pos = this.banners.deskripsi.search('<youtube>');
          this.addString(this.banners.deskripsi, this.pos, '<baris>');
          this.pos = 0;
          this.pos = this.banners.deskripsi.search('</youtube>');
          this.addString(this.banners.deskripsi, this.pos + 10, '<baris>');
          let yDesc = this.banners.deskripsi.replace(
            '<youtube>',
            '<adayoutube>'
          );
          this.banners.deskripsi = yDesc.replace('</youtube>', '</adayoutube>');
        }
      }
      this.deskripsi = this.banners.deskripsi.split('<baris>');
      for (let i = 0; i < this.deskripsi.length; i++) {
        if (this.deskripsi[i].includes('<adaiklan>')) {
          let x = this.deskripsi[i].search('<adaiklan>');
          let y = this.deskripsi[i].search('</adaiklan>');
          this.listIdIklan.push(this.deskripsi[i].slice(x + 10, y));
          this.deskripsi[i] = this.deskripsi[i].replace('<adaiklan>', '');
          this.deskripsi[i] = this.deskripsi[i].replace('</adaiklan>', '');
        }
        if (this.deskripsi[i].includes('<adayoutube>')) {
          this.deskripsi[i] = this.deskripsi[i].replace('<adayoutube>', '');
          this.deskripsi[i] = this.deskripsi[i].replace('</adayoutube>', '');
        }
      }
      if (this.listIdIklan.length > 0) {
        this.getIklan();
      }
      console.log('desc temp', this.banners.deskripsi);
      console.log('desc split', this.deskripsi);
      console.log('listIdIklan', this.listIdIklan);
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        return parts
          .pop()
          .split(';')
          .shift();
      }
      return null;
    }
  },
  created() {
    const userCookie = this.getCookie('user');

    if (userCookie) {
      // Decode the URL-encoded data
      const decodedUserData = decodeURIComponent(userCookie);

      try {
        // Parse the JSON data in the decoded cookie
        const userData = JSON.parse(decodedUserData);

        // Access the "token" property
        this.userToken = userData.token;
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    }
    // this.dataToken = this.$cookies.get('user');
    this.showBanners();
  }
};
</script>

<style scoped></style>
